import makeStyles from "utils/makeStyles";

export default makeStyles(theme => ({
    wrapper: {
        backgroundColor:"white",
        borderRadius:"10px"
    },
    header: {
        padding: "10px 20px",
    },
    toolbar: {
        padding: "16px 24px",
    },
    crudButtons: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    content: {
        minHeight: 350,
        padding: "10px 20px",
    }
}));